export const financialInfoTabId = '12-12-12';
// '-' is const from api
export const NOT_AVAILABLE_PAY_CODE = '-';
export const ptoMultiRateId = 'ca7f0df1-f3b1-4868-bc2b-bf1311400ae4';
